/* Playground grant directory: filters and pages the rows already in the HTML.
   Without JavaScript every row shows, so search engines read the full list. */
(function () {
  "use strict";
  document.querySelectorAll(".gd-dir").forEach(function (root) {
    root.classList.add("gd-js");
    var form = root.querySelector(".gd-filters");
    var list = root.querySelector("[data-list]");
    if (!form || !list) return;
    var rows = Array.prototype.slice.call(list.querySelectorAll(".gd-row"));
    var countEl = root.querySelector("[data-count]");
    var perEl = root.querySelector("[data-per]");
    var pagerEl = root.querySelector("[data-pager]");
    var page = 1;
    var empty = document.createElement("p");
    empty.className = "gd-empty";
    empty.textContent = "No programs match these filters. Try Any status or Anyone.";
    empty.hidden = true;
    list.appendChild(empty);

    var listbar = root.querySelector(".gd-listbar") || list;
    listbar.setAttribute("tabindex", "-1");

    // Height of whatever the theme pins to the top of the screen (Superstore's sticky header).
    function pinnedHeight() {
      var h = 0;
      document.querySelectorAll("header, [class*='header'], .shopify-section-group-header-group").forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== "sticky" && cs.position !== "fixed") return;
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > h && r.width > window.innerWidth / 2) h = r.bottom;
      });
      return h;
    }

    // After Next or Previous: bring the "Showing 26 to 50" line to just below the pinned header.
    function scrollToList() {
      var top = listbar.getBoundingClientRect().top - pinnedHeight() - 12;
      if (top < 0 || top > window.innerHeight * 0.6) {
        var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: window.pageYOffset + top, behavior: reduce ? "auto" : "smooth" });
      }
      listbar.focus({ preventScroll: true });
    }

    function val(name) {
      var el = form.querySelector('[data-f="' + name + '"]');
      return el ? el.value.trim() : "";
    }

    function matches(r) {
      var d = r.dataset, who = val("who"), st = val("status"), ol = val("outlook"), county = val("county"), q = val("q").toLowerCase();
      if (who && (" " + d.who + " ").indexOf(" " + who + " ") < 0) return false;
      if (st === "now" && d.status !== "open" && d.status !== "rolling" && d.status !== "no-deadline") return false;
      if (st && st !== "now" && d.status !== st) return false;
      if (ol && d.outlook !== ol) return false;
      // A county shows its own programs plus everything statewide and national
      if (county && d.counties !== "||" && d.counties.indexOf("|" + county + "|") < 0) return false;
      if (q && d.text.indexOf(q) < 0) return false;
      return true;
    }

    function render(scroll) {
      var hits = rows.filter(matches);
      var per = parseInt(perEl ? perEl.value : "0", 10) || hits.length || 1;
      var pages = Math.max(1, Math.ceil(hits.length / per));
      if (page > pages) page = pages;
      var start = (page - 1) * per, end = Math.min(start + per, hits.length);
      rows.forEach(function (r) { r.hidden = true; });
      hits.slice(start, end).forEach(function (r) { r.hidden = false; });
      empty.hidden = hits.length > 0;
      if (countEl) {
        countEl.textContent = !hits.length ? "0 programs"
          : pages === 1 && hits.length === rows.length ? rows.length + " programs"
          : "Showing " + (start + 1) + " to " + end + " of " + hits.length + " programs";
      }
      if (pagerEl) {
        pagerEl.innerHTML = "";
        if (pages > 1) {
          var prev = document.createElement("button");
          prev.type = "button"; prev.textContent = "Previous"; prev.disabled = page === 1;
          prev.addEventListener("click", function () { page--; render(true); });
          var label = document.createElement("span");
          label.textContent = "Page " + page + " of " + pages;
          var next = document.createElement("button");
          next.type = "button"; next.textContent = "Next"; next.disabled = page === pages;
          next.addEventListener("click", function () { page++; render(true); });
          pagerEl.appendChild(prev); pagerEl.appendChild(label); pagerEl.appendChild(next);
        }
      }
      if (scroll) scrollToList();
    }

    form.addEventListener("input", function () { page = 1; render(false); });
    form.addEventListener("change", function () { page = 1; render(false); });
    if (perEl) perEl.addEventListener("change", function () { page = 1; render(false); });
    render(false);
  });
})();
